/**
 * The founder's quick feedback on a BAM IQ answer (D153, D154): what was
 * off, picked with taps, shared by the app and the server
 * (api/_bamiq/actions.js), which keeps only these.
 *
 * And the training cycle's vocabulary (Coleman, 2026-10-25; docs/bam-iq/FOUNDER_TRAINING_CYCLE.md): the five
 * capabilities a case exercises (never modes or templates), the five things he scores, the causes a failure is
 * traced to before anything changes, and the safety checks that pass or fail but are never traded for a score.
 */
export const FEEDBACK_REASONS = ["Wrong", "Missed the point", "Weak suggestion", "Too long", "Too vague", "Preachy", "Wrong level", "Sources", "Format",
  "Too absolute", "Generic question", "Didn't challenge", "Canned phrasing"];
export const VERDICTS = ["better", "same", "worse"];
// The founder's call on an answer, optional (Coleman, 2026-11-01: "not necessarily needing thumbs up/down because it
// could be both/indifferent"): good, mixed, off, or none at all ("note": just what he said).
export const RATINGS = ["up", "mixed", "down", "note"];
export const OVERALL = [["up", "Good"], ["mixed", "Mixed"], ["down", "Off"]];
export const ratingLabel = (r) => ({ up: "good", mixed: "mixed", down: "off", note: "a note" }[r] || "a note");

// How long a saved note can be. The note is now his main feedback instrument: he talks it in, and one answer
// can earn a full talk-through of what was good and what was off (Coleman, 2026-10-27). The capture box, the
// server save and the case drafter all hold to this one number.
export const NOTE_MAX = 12000;

export const CAPABILITIES = ["Diagnose", "Design", "Think together", "Develop the coach", "Help execute"];
export const DIMENSIONS = ["Basketball intelligence", "Conversational quality", "Practical usefulness", "Coaching development", "Presentation and resources"];
export const CAUSES = ["Basketball reasoning", "Scientific or factual accuracy", "Source retrieval and attribution", "Conversational judgment",
  "Practical usefulness", "Formatting or missing components", "Context or memory", "Technical or UI"];
export const SAFETY_CHECKS = ["Privacy", "Attribution", "Coach-controlled saving"];
export const SAFETY_VALUES = ["pass", "fail"];
